import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

export function getArray(val) {
  return isArray(val) ? val : [];
}

export function getObject(val) {
  return isObject(val) ? val : {};
}
